import React, { Component } from 'react'
import vMasker from 'vanilla-masker'
import { FormattedMessage, injectIntl } from 'react-intl'
import { TextField } from '@mui/material'
import {
  ensureEnglishNumber,
  toPersianDigit,
  reverseString,
} from '../../../helpers/generalHelpers'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import { getRawMessage } from '../../../locale'
import settings from '../../../settings'

import './money-input.css'
import RawHtml from 'stories/components/RawHtml'

const { locales } = settings

export const defaultCurrencyOptions = [
  { value: 'irr', label: getRawMessage('currency.irr') },
  { value: 'irt', label: getRawMessage('currency.irt') },
  { value: 'usd', label: getRawMessage('currency.usd') },
  { value: 'eur', label: getRawMessage('currency.eur') },
]

class MoneyInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false, maskedValue: '' }
  }

  // a bit confusing. basically string is reversed before and after masking
  maskMoney = (rawValue) =>
    reverseString(
      vMasker.toPattern(reverseString(rawValue), '999,999,999,999,999,999')
    )

  unMaskMoney = (rawValue) => rawValue.replace(/,/g, '')

  onInputChange = ({ target: { value } }) => {
    this.updateState({
      value,
      shouldUpdateParent: true,
    })
  }

  updateState = ({ value, shouldUpdateParent }) => {
    const maskedValue = this.maskMoney(ensureEnglishNumber(value))

    this.setState({ maskedValue: maskedValue }, () => {
      shouldUpdateParent && this.props.onChange(this.unMaskMoney(maskedValue))
    })
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () =>
    this.applyMasking()
      ? toPersianDigit(this.state.maskedValue)
      : this.state.maskedValue

  translateCurrency = (currencySymbol) => {
    if (currencySymbol) {
      const currencies = ['eur', 'usd', 'irr', 'irt']
      const persianNames = ['یورو', 'دلار آمریکا', 'ریال', 'تومان']
      const currencyIndex = currencies.indexOf(currencySymbol)

      if (currencyIndex !== -1) {
        return `${persianNames[currencyIndex]}`
      } else {
        return `${currencySymbol}`
      }
    } else {
      return ''
    }
  }

  formatPriceToShow = (price) => toPersianDigit(this.maskMoney(String(price)))

  generateDescription = (desc = '', max, min) => {
    if (!this.applyMasking()) return <RawHtml content={desc} />

    const currencyName = this.translateCurrency(this.props.currency)

    if (max && min) {
      return `${(<RawHtml content={desc} />)} رقمی بین ${this.formatPriceToShow(
        min
      )} و ${this.formatPriceToShow(max)} ${currencyName}`
    }

    if (min) {
      return `${(
        <RawHtml content={desc} />
      )} رقمی بزرگتر از ${this.formatPriceToShow(min)} ${currencyName}`
    }

    if (max) {
      return `${(
        <RawHtml content={desc} />
      )} رقمی کوچکتر از ${this.formatPriceToShow(max)} ${currencyName}`
    }

    return <RawHtml content={desc} />
  }

  applyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      min_value: min,
      max_value: max,
      required,
      currency,
      touched,
      error,
      description,
      customized,
    } = this.props

    const classNames = {
      'formz-money-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const currencyHint = currency ? (
      <span>
        (
        <FormattedMessage
          id={`currency.${currency}`}
          defaultMessage={currency}
        />
        )
      </span>
    ) : (
      ''
    )
    const inputProps = {
      name,
      type: 'text',
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {currencyHint} {required && '(*)'}
            </div>

            <div className="formz-field-description">
              {this.generateDescription(description, max, min)}
            </div>

            <input
              className="formz-input-field ltr-on-type"
              placeholder={placeholder}
              {...inputProps}
            />
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField
          {...inputProps}
          label={label || placeholder}
          error={Boolean(error)}
        />
      </FieldWrapper>
    )
  }
}

export default injectIntl(MoneyInput)
